document.addEventListener('DOMContentLoaded',function(){

    gsap.fromTo(
        ".gsap-fade-in", // アニメーションさせる要素
        {
          y: 50, // アニメーション開始前の縦位置(下に100px)
          autoAlpha: 0, // アニメーション開始前は透明
        },
        {
          y: 0, // アニメーション後の縦位置(上に100px)
          autoAlpha: 1, // アニメーション後に出現(透過率0)
          stagger: 1, // 0.2秒遅れて順番に再生
          scrollTrigger: {
            trigger: ".gsap-fade-in", // アニメーションが始まるトリガーとなる要素
            toggleActions: "play none none reverse", // 上スクロールで戻る
            start: "top center", // アニメーションの開始位置

          },
        }
      );

    gsap.fromTo(
        ".gsap-fade-in--2", // アニメーションさせる要素
        {
            y: 50, // アニメーション開始前の縦位置(下に100px)
            autoAlpha: 0, // アニメーション開始前は透明
        },
        {
            y: 0, // アニメーション後の縦位置(上に100px)
            autoAlpha: 1, // アニメーション後に出現(透過率0)
            stagger: 0.5, // 0.2秒遅れて順番に再生
            scrollTrigger: {
            trigger: ".gsap-fade-in--2", // アニメーションが始まるトリガーとなる要素
            toggleActions: "play none none reverse", // 上スクロールで戻る
            start: "top center", // アニメーションの開始位置
            // markers: true
        },
        }
);
    gsap.fromTo(
        ".gsap-fade-in--3", // アニメーションさせる要素
        {
            y: 50, // アニメーション開始前の縦位置(下に100px)
            autoAlpha: 0, // アニメーション開始前は透明
        },
        {
            y: 0, // アニメーション後の縦位置(上に100px)
            autoAlpha: 1, // アニメーション後に出現(透過率0)
            stagger: 0.5, // 0.2秒遅れて順番に再生
            scrollTrigger: {
            trigger: ".gsap-fade-in--3", // アニメーションが始まるトリガーとなる要素
            toggleActions: "play none none reverse", // 上スクロールで戻る
            start: "top center", // アニメーションの開始位置
            // markers: true
        },
        }
);

gsap.fromTo(
  ".gsap-fade-in-4", // アニメーションさせる要素
  {
    y: 50, // アニメーション開始前の縦位置(下に50px)
    autoAlpha: 0, // アニメーション開始前は透明
  },
  {
    y: 0, // アニメーション後の縦位置(元の位置に)
    autoAlpha: 1, // アニメーション後に完全に表示(透過率0)
    stagger: 0.5, // 0.5秒遅れて順番に再生
  }
);





  // メディアクエリを設定
  const mediaQuery = window.matchMedia("(min-width: 768px)");
    // メディアクエリが真の場合のみアニメーションを設定
  if (mediaQuery.matches) {
    gsap.to('.text-rap', {
      scrollTrigger: {
        trigger: '.contents-rap',
        start: 'top center',
        end: 'center center', // ビューポートの中央に来たときにアニメーションを止める
        scrub: true
      },
      y: '45%', // トリガー要素をビューポートの高さの50%分だけ垂直に動かす
      ease: 'none'
    });

gsap.to('.banner__heading-rap', {
  scrollTrigger: {
    trigger: '.banner__content',
    start: 'top center', // 要素の上端がビューポートの中央に来たときにトリガー
    end: 'center center+=15%', // 要素の下端がビューポートの中央に来たときにトリガー
    scrub: true, // スクロールに合わせてアニメーションをスムーズにする
    pin: true, // 要素を固定する
    pinSpacing: false, // 固定された要素の間隔を保持しない
    // markers: true // 開発用のマーカーを表示する
  },
  ease: 'none'
});



gsap.to('.c-background', {
  scrollTrigger: {
    trigger: '.c-background',
    start: 'top bottom', // トリガーがビューポートの下部に来たときに開始
    end: 'bottom top', // トリガーがビューポートの上部に来たときに終了
    scrub: true // スクロールに合わせてアニメーションを滑らかにする
  },
  backgroundPosition: 'center center', // 背景画像の位置を上に移動
  ease: 'none' // アニメーションのイージングを無効にして滑らかにする
});


}})